import Vue from 'vue';
import Router from 'vue-router';
// import HomePage from "@/components/page/HomePage";
// import ChatPage from "@/components/page/ChatPage";
// import UserPage from "@/components/page/UserPage";
// import ImageView from "@/components/page/ImagePage";
// import RemindPage from "@/components/page/RemindPage";
// import SetRemindPage from "@/components/page/SetRemindPage";

const HomePage = () => import(/* webpackChunkName: "homepage" */ "@/components/page/HomePage");
const ChatPage = () => import(/* webpackChunkName: "chatpage" */ "@/components/page/ChatPage");
const UserPage = () => import(/* webpackChunkName: "userpage" */ "@/components/page/UserPage");
const ImageView = () => import(/* webpackChunkName: "imagepage" */ "@/components/page/ImagePage");
const RemindPage = () => import(/* webpackChunkName: "remindpage" */ "@/components/page/RemindPage");
const SetRemindPage = () => import(/* webpackChunkName: "setremindpage" */ "@/components/page/SetRemindPage");
import config from '@/global/config';
import _gDic from '@/global/globalDic';

Vue.use(Router);
// 获取url参数
var convertQuery = function (params) {
  var query = params.split('&');
  var out = {};
  for (var i = 0; i < query.length; i++) {
    var arr = query[i].split('=');
    var key = arr[0];
    var value = arr[1];
    out[key] = value;
  }
  return out;
};
// 是否为空
var isEmpty = function (input) {
  return input === null || input === undefined || input === '';
};

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/home/:params',
      name: 'home',
      component: HomePage
    },
    {
      path: '/chat/:params',
      name: 'chat',
      component: ChatPage
    },
    {
      path: '/user/:params',
      name: 'user',
      component: UserPage
    },
    {
      path: '/image/:msg_id',
      name: 'image',
      component: ImageView
    },
    {
      path: '/remind/:params',
      name: 'remind',
      component: RemindPage
      
    },
    {
      path: '/setRemind/:params',
      name: 'setRemind',
      component: SetRemindPage
    },
    {
      path: '/entry/:params',
      name: 'entry',
      beforeEnter: function (to) {
        var urlprarms = convertQuery(to.params.params);
        if (!isEmpty(urlprarms['hasTopbar'])) {
          _gDic.set('hasTopbar', urlprarms['hasTopbar'] || true);
        }
        if (!isEmpty(urlprarms['hideHomeBtn'])) {
          _gDic.set('hideHomeBtn', urlprarms['hideHomeBtn'] || true);
        }
        config.get('entry-handler')(router, to.params.params);
      }
    },
    {
      path: '*',
      redirect: function () {
        return '/';
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name === 'home') {
    typeof config.get('title-handler') === 'function' && config.get('title-handler')(to, '最近会话');
  }
  // 如果用户未能验证身份，则 `next` 会被调用两次
  next()
})

export default router;
